<template>
  <v-combobox
    label="Personality Traits"
    v-model="profile.behavioralCompetencies"
    @input="submit"
    :class="{ 'animated infinite shake delay-2s': profile.behavioralCompetencies.length > 5 }"
    :color="themes.candidate.light.input"
    :menu-props="{ maxHeight: '200px', offsetY: true }"
    :items="behavioralCompetencies"
    :error="errors.length > 0"
    :error-messages="errors"
    :loading="loading"
    item-text="name"
    return-object
    multiple
    attach
  >
    <template slot="selection" slot-scope="{ item, selected, parent }">
      <v-chip
        @input="parent.selectItem(item)"
        :key="`behavioral-competency-${item.id}`"
        :color="themes.candidate.light.chip"
        :selected="selected"
      >
        {{ item.name }}
        <v-icon right :color="themes.candidate.light.cancel" @click="parent.selectItem(item)">
          mdi-close-circle
        </v-icon>
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  created() {
    this.$store.dispatch('behavioralCompetencies/fetchAll')
  },
  props: {
    value: Array,
  },
  data() {
    return {
      // Loading indicator
      loading: false,
      // Model (object sent to API)
      profile: {
        behavioralCompetencies: this.value || [],
      },
    }
  },
  computed: {
    ...mapGetters({
      behavioralCompetencies: 'behavioralCompetencies/all',
    }),
    errors() {
      if (this.value.length > 5 || this.profile.behavioralCompetencies.length > 5) {
        return ['up to 5 traits allowed']
      }
      return []
    },
  },
  methods: {
    submit() {
      if (
        (this.profile.behavioralCompetencies.length < 6 || this.value.length > 5) &&
        this.value.map(x => x.id).join() !==
          this.profile.behavioralCompetencies.map(x => x.id).join()
      ) {
        this.loading = true
        this.$store
          .dispatch('candidate/profile/update', this.profile)
          .finally(() => (this.loading = false))
      }
      return
    },
  },
}
</script>
